import { checkEmail, checkExistingEmail, fetchDetails } from '@/api/project';

export const checkProjectEmail = (email) => {
  const params = {
    email,
  };

  return checkEmail(params);
};

export const checkProjectExistingEmail = (params) => {
  return checkExistingEmail(params);
};

export const getDetails = (projectId, params) => {
  return fetchDetails(projectId, params);
};
